import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) {
      toast.error("Passwords don't match");
      return;
    }
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password reset! You can now sign in.");
      navigate("/login");
    } catch (err) {
      toast.error(apiError(err));
    } finally { setBusy(false); }
  };

  if (!token) {
    return (
      <div className="silk-hero min-h-[70vh] flex items-center justify-center px-5 py-20">
        <div className="w-full max-w-md silk-card rounded-lg p-8 sm:p-10 text-center" data-testid="reset-password-invalid">
          <h1 className="font-display text-4xl text-foreground mb-4">Invalid link</h1>
          <p className="text-sm text-muted-foreground">This reset link is missing or malformed.</p>
          <p className="text-sm text-muted-foreground mt-6">
            <Link to="/forgot-password" className="cream-link" data-testid="reset-request-new-link">Request a new reset link</Link>
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="silk-hero min-h-[70vh] flex items-center justify-center px-5 py-20">
      <div className="w-full max-w-md silk-card rounded-lg p-8 sm:p-10">
        <h1 className="font-display text-4xl text-foreground mb-2">Set a new password</h1>
        <p className="text-sm text-muted-foreground mb-8">Choose a new password for your O.R.E.C account.</p>
        <form onSubmit={submit} className="space-y-5">
          <div>
            <Label htmlFor="password" className="text-xs uppercase tracking-wider text-muted-foreground">New password</Label>
            <Input id="password" data-testid="reset-password-input" type="password" required minLength={6} value={password}
              onChange={(e) => setPassword(e.target.value)} className="mt-2" placeholder="At least 6 characters" />
          </div>
          <div>
            <Label htmlFor="confirm" className="text-xs uppercase tracking-wider text-muted-foreground">Confirm password</Label>
            <Input id="confirm" data-testid="reset-password-confirm-input" type="password" required minLength={6} value={confirm}
              onChange={(e) => setConfirm(e.target.value)} className="mt-2" />
          </div>
          <Button data-testid="reset-password-submit-btn" type="submit" disabled={busy} className="w-full h-11 rounded-full">
            {busy ? "Resetting…" : "Reset password"}
          </Button>
        </form>
        <p className="text-sm text-muted-foreground mt-6 text-center">
          <Link to="/login" className="cream-link" data-testid="reset-back-to-login-link">Back to sign in</Link>
        </p>
      </div>
    </div>
  );
}
